import { Button, Card, CardContent, Grid, Typography, } from "@mui/material";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import {
  nbfCreatedOrderArray,
  nbfInvoice,
  nbfModificationItems,
  nbfOrderItems,
  nbfPrductionOrder,
  nbfProductionStatus
} from "../../../api/restApi";
import InvoiceModal from "../../../components/modals/InvoiceModal";
import MissingItemModal from "../../../components/modals/MissingItemModal";
import ProductionModal from "../../../components/modals/ProductionModal";
import customeri from '../../../data/customer';
import { customersData } from "../../../store/reducer/customersSlice";
import { generateBillForCustomer } from "../../../utils/helpers";
import { useAppSelector } from "../../../utils/hooks";
import { useSelector } from "react-redux";

const ProductionOrder = ({ orderProduction, selectedDate, handleStatus }) => {
  const role = useSelector((state) => state.currentUser.role);
  const name = useSelector((state) => state.currentUser.name);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [orderCustomer, setOrderCustomer] = useState([]);
  const [openProModal, setOpenProModal] = useState(false);
  const [statusModifyOrder, setStatusModifyOrder] = useState(false);
  const [openInvoice, setOpenInvoice] = useState(false);
  const [missItem, setMissItem] = useState([]);
  const [open, setOpen] = useState(false);
  const { customers } = useAppSelector(customersData);
  const [orderByCustomer, setOrderByCustomer] = useState("");
 

  async function callData() {
    try {
      setOrderCustomer(
        orderProduction?.map((pro) => {
          return {
            ...pro,
            ...findCustomer(pro.customerId),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (orderProduction) {
      callData();
    }
  }, [orderProduction]);
  const handleViewClick = async (row) => {
    let invoiceView = await nbfInvoice(selectedDate, row.id);
    console.log('invoiceView',invoiceView)
    let cust = await generateBillForCustomer({
      ...invoiceView,
      ...findCustomer(row.id),
    });

    setOrderByCustomer(cust);
    setOpenInvoice(true);
  };

  const findCustomer = (id) => {
    console.log(customeri,id);

    let cust = customeri.find((el) => el.id?.toString() === id?.toString());
    if (!cust) {
      cust = customers.find((el) => el.id?.toString() === id?.toString());
    }
    console.log(cust);
    let today = new Date();
    let date =
      today.getDate() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getFullYear();
    return {
      ...cust,
      label: cust.name_urdu,
      date: date,
      //   preparedBy: preparedBy,
      selectedDate: selectedDate,
    };
  };

  const today = new Date();
  today.setDate(today.getDate());
  const year = today.getFullYear();
  const month = (today.getMonth() + 1).toString().padStart(2, "0");
  const day = today.getDate().toString().padStart(2, "0");
  const todaysDate = `${year}-${month}-${day}`;

  const isToday = selectedDate === todaysDate;
  console.log(orderProduction);

  const handleEditClick = async (row) => {
    if (row.status == undefined) {
      setStatusModifyOrder(false);
    } else setStatusModifyOrder(true);
    setSelectedRow(row);
    setOpenProModal(true);
  };

  const handleClose = () => {
    setOpenProModal(false);
  };

  const handleAlert = async (row) => {
    const nbfCreatedOrder = await nbfCreatedOrderArray(selectedDate, row.id);
    //console.log(nbfCreatedOrder);
    if (row.id==90122) {
      return Swal.fire({
        icon: "error",
        title: "Sorry!",
        text: "you can't Dispatche Fair-Price Order!",
        // width:'90%'
      });
    } else { const confirmed = await Swal.fire({
      title: "Are you sure?",
      text: "Do You want to submit this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Submit it!",
      // width:'90%'
    });
  
    let missingOrder = [];
    row.order.map((item) => {
      console.log(item)
      let productID = item.id;
      let modifiedItem = nbfCreatedOrder.find(
        (prod) => prod.id + "" === productID + ""
      );
      if (modifiedItem && item.quantity >= modifiedItem.quantity) {
        return;
      } else {
        // missingOrder.push({
        //   id: item.id,
        //   reason: "",
        //   quantityMissing:item.quantity ?  modifiedItem.quantity - item.quantity:modifiedItem.quantity,
        //   ProductName:item.name_urdu,
        // });
      }
    });
    setMissItem(missingOrder);

    if (confirmed.isConfirmed) {
      const order1 = await nbfModificationItems(selectedDate, row.id);
      const order2 = await nbfOrderItems(selectedDate, row.id);
      
      const order = order1.length !== 0 ? order1 : order2;
      const status = "production";
      const customerId = row.id;
      await nbfPrductionOrder(order, status,customerId,name,selectedDate);
      try {
        if (missingOrder.length === 0) {
          // change the status
          const date = selectedDate;
          const id = row.id;
          await nbfProductionStatus(date, id);
          toast.success("Successfully Submit Order !", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
          handleStatus(selectedDate);
        } else {
          setOpen(true);
          setSelectedRowId(row.id);
        }
      } catch (error) {
        console.error("Error saving order: ", error);
        toast.error("Error saving order", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    } else {
      return;
    }
  };
  }
  const missingMOdalClose = () => {
    setOpen(false);
  };
  
  return (
    <div>
    <Stack alignItems="center" spacing={1} marginTop="0rem">
    <Box sx={{ flexGrow: 0, padding: { xs: "1rem", md: "1rem" } }}>
      <Grid item xs={12} md={6}>
      <Card 
          alignItems='start'
                sx={{
                  width: "100%", 
                  marginTop: "0rem",
                  "@media (min-width: 300px)": {
                                width: 350, // Set the width to 100% for mobile view
                  },
                  "@media (min-width: 650px)": {
                                width: 650, // Set the width to 650px for screens wider than 650px
                  },
          }}
        >
    <CardContent>
        <Table
              marginRight="1rem"
              sx={{
                "@media (min-width: 315px)": {
                              width: 315, // Set the width to 100% for mobile view
                },
                "@media (min-width: 620px)": {
                              width: 620, // Set the width to 650px for screens wider than 650px
                },
        }}
            aria-label="simple table"
        >
            <TableHead style={{ backgroundColor: "#f5f5f5", height: "25px", align: 'start',width:'100%' }}>
              <TableRow sx={{ justifyContent:'start',width:'100%'}}>
              <TableCell>
                <Typography fontSize={"18px"} align="center">
                  ID
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  align="center"
                  fontSize={"18px"}
                >
                  CUSTOMER  
                </Typography>
              </TableCell>
              <TableCell>
                <Typography align="center" fontSize={"18px"} >
                  ACTION
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {orderCustomer &&
              orderCustomer.map((row, index) => {
                return (
                  <>
                    <TableRow
                      key={index}
                    >
                    <TableCell align="start" style={{ width:"0%", fontSize: 15,}}>
                        {row.id.length > 5 ? row.id.slice(0, 5) : row.id}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{
                          fontSize: "17px",
                          paddingLeft: "10px",
                          wordWrap: 'break-word', maxWidth: '100px',
                          fontFamily: "NotoNastaliqUrdu",
                          width:"40%"
                        }}
                      >
                        {row.name_urdu}{" "}
                      </TableCell>
                      <TableCell
                      align="center"
                        style={{
                          height: "25px",
                          fontSize: "14px",
                          width:"40%",
                          justifyContent:"end"

                        }}
                      >
                        <Button
                              style={{justifyContent: 'center', width: '4rem',marginLeft:'1rem' }}
                              variant="outlined"
                              onClick={() => handleViewClick(row)}
                            >
                              View
                            </Button>
                          <Button
                                style={{justifyContent: 'center', width: '4rem',marginLeft:'1rem' }}
                              variant="outlined"
                            onClick={() => handleEditClick(row)}
                          >
                            Edit
                          </Button>
                          {role !=="cs" &&(   
                          <Button
                              style={{justifyContent: 'center', width: '4rem',marginLeft:'1rem' }}
                              variant="outlined"
                            onClick={() => handleAlert(row)}
                          >
                            Update
                          </Button>
                          )}
                      </TableCell>
                    </TableRow>
                  </>
                );
              })}
          </TableBody>
        </Table>
        </CardContent>
        </Card>
      </Grid>
      </Box>
      </Stack>
      {orderByCustomer && (
        <InvoiceModal
          openInvoice={openInvoice}
          orderByCustomer={orderByCustomer}
          setOpenInvoice={setOpenInvoice}
        />
      )}
      <ProductionModal
        openProModal={openProModal}
        handleClose={handleClose}
        selectedRow={selectedRow}
        selectedDate={selectedDate}
        handleStatus={handleStatus}
        statusModifyOrder={statusModifyOrder}
      />
      <MissingItemModal
        handleClose={missingMOdalClose}
        open={open}
        missItem={missItem}
        selectedDate={selectedDate}
        selectedRowId={selectedRowId}
        handleStatus={handleStatus}
      />
    </div>
  );
};

export default ProductionOrder;
